// Per-item palette, keyed by raw API item names (not display names —
// `renameItem` transforms these). Hand-tuned so each hue reads distinctly in
// the pie and stays dark enough for the white item icon that sits on it as a
// badge fill.
export const MATERIAL_COLORS = {
  "Glass - Bottle": "#fd3d3d",
  Cups: "#ff8543",
  Cigarette: "#a9834e",
  Packaging: "#efc44d",
  "Plastic - Wrapper": "#bbc842",
  "Plastic - Bottle": "#5a8142",
  "Metal - Can": "#35a3a3",
  Placeholder: "#7ba4f9",
  Bags: "#6452d4",
  Tissue: "#a959c7",
  Mask: "#ee9ad0",
  Others: "#808080",
};

// Fallback for item types not in MATERIAL_COLORS (e.g. the API returns a name
// we haven't mapped). Both the pie and the stats breakdown use this via
// materialColor(), so an unmapped item still gets a colour — and the same one
// in both places.
export const DEFAULT_MATERIAL_COLOR = "#799866";

export function materialColor(itemName) {
  return MATERIAL_COLORS[itemName] || DEFAULT_MATERIAL_COLOR;
}

// Leaderboard page size. Shared between the Leaderboard's infinite scroll and
// the map's country prefetch, whose warmed cache key must match the params the
// Leaderboard will request.
export const LEADERBOARD_PAGE_SIZE = 20;

// The `tabItems` value the Teams ranking is requested with: the backend returns
// teams and superteams as one ranked list. Shared so the Leaderboard's pages and
// TeamFilter's suggestion request keep one SWR cache key.
export const MERGED_TAB_ITEMS = "teams_and_superteams";

// The `include` value that opts `/dashboards/teams?search=` into returning
// superteam rows alongside teams (stridy_backend PR #54). Without it the search
// returns teams only, so the search box can't reach a superteam.
//
// Opting in changes the row shape: superteam rows come first and their `id` is an
// opaque string ("st_5") rather than an Integer, so every consumer must route the
// row by its `type` — `superteam` to `?superteam=`, `team` to `?team=`. Sending an
// "st_5" to `?team=` is parsed with to_i, yields 0, and returns an empty
// leaderboard rather than an error, so it reads as missing data instead of a bug.
// TeamFilter.onChange is the branch that keeps that from happening.
//
// Temporary: the backend drops the gate and always includes superteams once every
// dashboard environment sends the param, at which point this constant and its
// call site go away.
export const TEAM_SEARCH_INCLUDE = "superteams";

// The `sortBy` value every leaderboard list is ordered by until the user picks
// another column (see Leaderboard.SORT_COLUMNS). It is also the backend's own
// default, but it is sent explicitly so that the requests the Leaderboard makes
// and the ones TeamFilter/MapView warm the cache with share an SWR cache key.
export const DEFAULT_LEADERBOARD_SORT = "items_count";
